import { render, staticRenderFns } from "./RentalPlan.vue?vue&type=template&id=e8b28652&scoped=true"
import script from "./RentalPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./RentalPlan.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RentalPlan.vue?vue&type=style&index=0&id=e8b28652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b28652",
  null
  
)

export default component.exports